import { render, staticRenderFns } from "./ArticleColorsDropdown.vue?vue&type=template&id=e2bba348&scoped=true&"
import script from "./ArticleColorsDropdown.vue?vue&type=script&lang=js&"
export * from "./ArticleColorsDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2bba348",
  null
  
)

export default component.exports